// extracted by mini-css-extract-plugin
export default {"item":"Item_item__VisEJ","item_trap":"Item_item_trap__nnZeI","item_food":"Item_item_food__l3BuJ"};